import './settings/settings-leaf.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from './ui.tsx';
import { OPENAPI_JSON_PATH, OPENAPI_YAML_PATH } from '../api/openapi.ts';

/**
 * The way in to the API reference from Settings (owners only).
 *
 * A card rather than the reference itself, because the reference is eighty-odd
 * endpoints with a request console attached — a page, not a panel, and it
 * would bury every setting below it. This is the same shape the subscription
 * takes: the thing that belongs in the rail is the door, not the room.
 */
export default function ApiDocsSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="card work-section settings-leaf mb-6" aria-labelledby="api-docs-heading">
      <div className="work-section-heading">
        <h2 id="api-docs-heading" className="mb-4 text-lg font-semibold">
          {t('apiDocs.title')}
        </h2>
      </div>
      <p className="mb-4 text-sm text-[color:var(--color-muted)]">{t('apiDocs.sectionDescription')}</p>

      <div className="flex flex-wrap items-center gap-3">
        <Button variant="primary" onClick={() => navigate('/settings/api')}>
          {t('apiDocs.open')}
        </Button>
        <span className="text-xs text-[color:var(--color-muted)]">
          <a
            className="font-mono text-[color:var(--color-brand)] hover:underline"
            href={OPENAPI_JSON_PATH}
            target="_blank"
            rel="noreferrer"
          >
            openapi.json
          </a>
          <span className="mx-2">·</span>
          <a
            className="font-mono text-[color:var(--color-brand)] hover:underline"
            href={OPENAPI_YAML_PATH}
            target="_blank"
            rel="noreferrer"
          >
            openapi.yaml
          </a>
        </span>
      </div>
    </section>
  );
}
